import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

export type ChartName =
  | 'total_data_assets'
  | 'assets_with_description'
  | 'assets_with_pii'
  | 'assets_with_tier'
  | 'assets_with_owners'
  | 'healthy_data_assets';

export type ChartDataPoint = {
  count: number;
  day?: number;
  term?: string;
  group?: string;
};

export type ChartData = {
  results: ChartDataPoint[];
};

export type DataInsightsResponse = Partial<Record<ChartName, ChartData>>;

export type FetchDataInsightsParams = {
  chartNames: ChartName[];
  startDate: number;
  endDate: number;
  filter?: Record<string, unknown>;
};

export type FetchSingleChartParams = {
  chartName: ChartName;
  startDate: number;
  endDate: number;
};

export const fetchDataInsights = async (params: FetchDataInsightsParams): Promise<DataInsightsResponse> => {
  const { chartNames, startDate, endDate, filter } = params;

  const response = await openMetadataApiClient.get<DataInsightsResponse>(
    '/analytics/dataInsights/system/charts/listChartData',
    {
      params: {
        chartNames: chartNames.join(','),
        start: startDate,
        end: endDate,
        ...(filter && { filter: JSON.stringify(filter) }),
      },
    }
  );

  return response.data;
};

export const fetchSingleChart = async (params: FetchSingleChartParams): Promise<ChartData> => {
  const { chartName, startDate, endDate } = params;

  const response = await openMetadataApiClient.get<ChartData>(
    `/analytics/dataInsights/system/charts/name/${chartName}/data`,
    {
      params: {
        start: startDate,
        end: endDate,
      },
    }
  );

  return response.data;
};
